<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div>
        <navbar>
            <template v-slot:navbarname>

            </template>
        </navbar>

        <div class="sticky-top text-right">

            <b-button
                    v-if="editItemId > 0"
                    variant="success"
                    class="btn-round"
                    @click="updateText">{{$t('saveTitle')}}
            </b-button>
            <b-button
                    v-else
                    variant="success"
                    class="btn-round"
                    @click="storeText">{{$t('saveTitle')}}
            </b-button>

        </div>

        <br>
        <br>


        <b-card title="New Title">

            <b-form-group label="Title">
                <b-input v-model="titleText"></b-input>
            </b-form-group>

        </b-card>

        <b-card title="Titles">

            <table class="table table-bordered">
                <thead>
                <tr>
                    <th>#</th>
                    <th>title</th>
                    <th>action</th>
                </tr>
                </thead>

                <tbody v-if="titles.length > 0">
                <tr
                        :key="index"
                        v-for="(item,index) in titles">
                    <td>{{++index}}</td>
                    <td>{{item.setting_value}}</td>
                    <td>
                        <a
                                class="mr-3"
                                @click.prevent="editItem(item)"
                                href="#">edit</a>
                        <a
                                @click.prevent="deleteTitle(item.setting_id)"
                                class="text-danger" href="#">delete</a>
                    </td>
                </tr>
                </tbody>

            </table>

        </b-card>

    </div>
</template>

<script>
    import Navbar from "../../Partials/Navbar";
    import Http from '../../../Services/HttpService/HttpService'
    import Notificaion from '../../../Services/Notification/Nottification'

    export default {
        name: "Index",
        components: {Navbar},
        data() {
            return {
                isSubmit: false,
                editItemId: 0,
                titleText: null,
                titles: [],
            }
        },
        methods: {
            editItem(myItem) {
                this.editItemId = myItem.setting_id;
                this.titleText = myItem.setting_value;
                window.scrollTo(0, 0);
            },
            getTitles() {
                this.$Progress.start();
                this.isSubmit = false;
                Http.get(Http.apiurlV2() + 'setting/order/index')
                    .then(response => {
                        this.isSubmit = true;
                        this.$Progress.finish();
                        if (response.data.status_code === Http.ok()) {
                            this.titles = response.data.data.titles;
                        }
                    })
                    .catch(error => {
                        this.$Progress.finish();
                    })


            },
            deleteTitle(myId) {

                if (confirm(this.$t('alertText'))) {
                    this.$Progress.start();
                    Http.get(Http.apiurlV2() + 'setting/order/delete/' + myId)
                        .then(response => {
                            this.$Progress.finish();
                            if (response.data.status_code === Http.ok()) {
                                this.getTitles();
                                Notificaion.success(response.data.message);

                            }
                        })
                        .catch(error => {
                            this.$Progress.finish();
                        })
                }


            },
            storeText() {

                if (this.titleText === null) {
                    Notificaion.error("please fill title field");
                    return;
                }

                this.$Progress.start();
                Http.post(Http.apiurlV2() + 'setting/order/store', {
                    type: 'order_cancel',
                    title: this.titleText,
                })
                    .then(response => {
                        this.$Progress.finish();
                        if (response.data.status_code === Http.ok()) {
                            this.titleText = null;
                            this.getTitles();
                            Notificaion.success(response.data.message);
                        }
                    })
                    .catch(error => {
                        this.$Progress.finish();
                    })
            },
            updateText() {

                if (this.titleText === null) {
                    Notificaion.error("please fill title field");
                    return;
                }

                this.$Progress.start();
                Http.post(Http.apiurlV2() + 'setting/order/update/' + this.editItemId, {
                    title: this.titleText,
                })
                    .then(response => {
                        this.$Progress.finish();
                        if (response.data.status_code === Http.ok()) {
                            this.titleText = null;
                            this.editItemId = 0;
                            this.getTitles();
                            Notificaion.success(response.data.message);
                        }
                    })
                    .catch(error => {
                        this.$Progress.finish();
                    })
            },
        },
        created() {
            this.getTitles();
        }

    }
</script>

<style scoped>

</style>